import clsx from "classnames";
import classes from "./styles.module.scss";
import { Button, Container, Stack } from "react-bootstrap";
import { Title } from "@/ui";

export const TrendingButtons = ({ className, bgColor, textColor, title, titleColor, items }) => {
  return (
    <div className={clsx(className, bgColor, textColor, classes.TrendingButtons)}>
      <Container className="mw-xl text-center">
        <Title title={title} className={clsx(titleColor, "mb-5")} />
        <Stack className="flex-row flex-wrap justify-content-center" gap={2}>
          {(items ?? []).map((i, idx) => (
            <Button
              key={idx}
              className="mb-1 px-3"
              variant={i.variant}
              href={i.href}
              target={i.open_in_new_tab ? "_blank" : undefined}
            >
              {i.label}
            </Button>
          ))}
        </Stack>
      </Container>
    </div>
  );
};

export default TrendingButtons;
